import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  border: none;
  display: flex;
  justify-content: space-between;
`;

const Span = styled.span`
  flex-grow: 6;
  font: ${props => props.theme.fontWeightMedium} 17px/32px ${props => props.theme.fontFamilyBody};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
`;

const Img = styled.img`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  border: 2px solid white;
  box-shadow: 0px 4px 8px rgba(50, 50, 71, 0.06), 0px 4px 4px rgba(50, 50, 71, 0.08);
`;

export default function WireCandidate({ title, contributor }) {
  const { profilePictureUrl, name } = contributor;
  return (
    <Container>
      <Span>{title}</Span>
      {!!profilePictureUrl && <Img src={profilePictureUrl} alt={name} />}
    </Container>
  );
}

WireCandidate.propTypes = {
  title: PropTypes.string.isRequired,
  contributor: PropTypes.shape({
    profilePictureUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
